import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { UseMutationOptions, useMutation } from 'react-query'
import { SuggestionRequest } from 'types'

interface RefineVideoParams {
  image_url: string
  topic: string
}

interface RefineVideoResponse {
  request: SuggestionRequest
}

type Options = Omit<UseMutationOptions<RefineVideoResponse, Error, RefineVideoParams>, 'mutationKey' | 'mutationFn'>

const refineVideo = async (
  workspaceId: number,
  designId: string,
  params: RefineVideoParams,
): Promise<RefineVideoResponse> => {
  const res = await sendToApi<RefineVideoResponse>(`/w/${workspaceId}/designs/${designId}/refine_video`, {
    method: 'POST',
    body: {
      image_url: params.image_url,
      topic: params.topic,
    },
  })

  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }

  return res.data
}

export const useRefineVideo = (designId: string, options?: Options) => {
  const workspaceId = useCurrentWorkspaceId()
  return useMutation<RefineVideoResponse, Error, RefineVideoParams>(
    (params) => refineVideo(workspaceId, designId, params),
    options,
  )
}
